import { Modal } from "react-bootstrap"
import { useGeneralStates } from "../../context/general-context"
import { ACTIONS } from "../../utils/globalUtils"

export default function SubscribeAlert() {
    const { state, dispatch } = useGeneralStates()
    
    function handleHideModal() {
        dispatch({ type: ACTIONS.setSubscribeAlertShow, payload: false })
    }

    return (
        <Modal 
            className="subscribe-alert-modal"
            size="md"
            centered
            show={state.subscribeAlertShow}
            onHide={handleHideModal}
        >
            <Modal.Title>
                Premium Feature
            </Modal.Title>
            <Modal.Body>
                This feature is available to clients who have acquired the 
                Full City Evaluation and Site Selection Personalized Report.
                <br />
                <br />
                For more information about this service, please contact us at consulting@prodensa.com
            </Modal.Body>
        </Modal>
    )
}
